import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Phone,
  Mail,
  MapPin,
  Facebook,
  Instagram,
  Linkedin,
} from "lucide-react";

const Footer = () => {
  const [hoveredLink, setHoveredLink] = useState("");
  const [hoveredIcon, setHoveredIcon] = useState("");
  const styles = {
    footer: {
      backgroundColor: "#0B2E7A",
      color: "#fff",
      marginTop: "50px",
      padding: "60px 5% 20px",
    },

    container: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "40px",
      maxWidth: "1400px",
      margin: "0 auto",
    },

    logo: {
      color: "#FFD400",
      fontSize: "28px",
      fontWeight: "700",
      marginBottom: "15px",
    },

    heading: {
      color: "#FFD400",
      marginBottom: "20px",
      fontSize: "20px",
      fontWeight: "600",
    },

    text: {
      color: "#d8d8d8",
      lineHeight: "1.8",
      fontSize: "15px",
    },

    list: {
      listStyle: "none",
      padding: 0,
      margin: 0,
    },

    link: {
      color: "#fff",
      textDecoration: "none",
      display: "block",
      marginBottom: "12px",
      transition: "0.3s",
      fontSize: "15px",
    },

    contactItem: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginBottom: "15px",
      color: "#d8d8d8",
    },

    socialContainer: {
      display: "flex",
      gap: "12px",
      marginTop: "20px",
    },

    socialIcon: {
      width: "42px",
      height: "42px",
      borderRadius: "50%",
      backgroundColor: "rgba(255,212,0,0.15)",
      border: "1px solid #FFD400",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#FFD400",
      cursor: "pointer",
      transition: "all 0.5s ease",
    },

    bottom: {
      borderTop: "1px solid rgba(255,255,255,0.2)",
      marginTop: "40px",
      paddingTop: "20px",
      textAlign: "center",
      color: "#d8d8d8",
      fontSize: "14px",
    },
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        {/* Company Info */}
        <div>
          <h2 style={styles.logo}>Jaina Enterprises</h2>

          <p style={styles.text}>
            Delivering trusted industrial solutions with innovation, quality,
            and customer satisfaction.
          </p>

          <div style={styles.socialContainer}>
            <div
              style={{
                ...styles.socialIcon,
                transform:
                  hoveredIcon === "facebook"
                    ? "translateY(-8px) rotate(360deg) scale(1.15)"
                    : "none",
                backgroundColor:
                  hoveredIcon === "facebook"
                    ? "#FFD400"
                    : "rgba(255,212,0,0.15)",
                color: hoveredIcon === "facebook" ? "#0B2E7A" : "#FFD400",
              }}
              onMouseEnter={() => setHoveredIcon("facebook")}
              onMouseLeave={() => setHoveredIcon("")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073c0 6.019 4.388 11.008 10.125 11.927v-8.437H7.078v-3.49h3.047V9.413c0-3.017 1.792-4.683 4.533-4.683 1.312 0 2.686.235 2.686.235v2.963h-1.514c-1.49 0-1.955.925-1.955 1.874v2.251h3.328l-.532 3.49h-2.796V24C19.612 23.081 24 18.092 24 12.073z" />
              </svg>
            </div>

            <div
              style={{
                ...styles.socialIcon,
                transform:
                  hoveredIcon === "instagram"
                    ? "translateY(-8px) rotate(360deg) scale(1.15)"
                    : "none",
                backgroundColor:
                  hoveredIcon === "instagram"
                    ? "#FFD400"
                    : "rgba(255,212,0,0.15)",
                color: hoveredIcon === "instagram" ? "#0B2E7A" : "#FFD400",
              }}
              onMouseEnter={() => setHoveredIcon("instagram")}
              onMouseLeave={() => setHoveredIcon("")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M7.75 2C4.574 2 2 4.574 2 7.75v8.5C2 19.426 4.574 22 7.75 22h8.5C19.426 22 22 19.426 22 16.25v-8.5C22 4.574 19.426 2 16.25 2h-8.5zm0 1.8h8.5a3.95 3.95 0 0 1 3.95 3.95v8.5a3.95 3.95 0 0 1-3.95 3.95h-8.5a3.95 3.95 0 0 1-3.95-3.95v-8.5A3.95 3.95 0 0 1 7.75 3.8zm8.9 1.35a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2zM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 1.8A3.2 3.2 0 1 1 8.8 12 3.2 3.2 0 0 1 12 8.8z" />
              </svg>
            </div>

            <div
              style={{
                ...styles.socialIcon,
                transform:
                  hoveredIcon === "Linkdin"
                    ? "translateY(-8px) rotate(360deg) scale(1.15)"
                    : "none",
                backgroundColor:
                  hoveredIcon === "Linkdin"
                    ? "#FFD400"
                    : "rgba(255,212,0,0.15)",
                color: hoveredIcon === "Linkdin" ? "#0B2E7A" : "#FFD400",
              }}
              onMouseEnter={() => setHoveredIcon("Linkdin")}
              onMouseLeave={() => setHoveredIcon("")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M4.98 3.5C4.98 4.88 3.86 6 2.48 6S0 4.88 0 3.5 1.12 1 2.48 1s2.5 1.12 2.5 2.5zM.5 8h4V24h-4V8zm7 0h3.84v2.19h.06c.54-1.02 1.86-2.09 3.83-2.09 4.1 0 4.86 2.7 4.86 6.2V24h-4v-7.8c0-1.86-.03-4.25-2.59-4.25-2.59 0-2.99 2.02-2.99 4.11V24h-4V8z" />
              </svg>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 style={styles.heading}>Quick Links</h3>

          <ul style={styles.list}>
            <Link
              to="/"
              style={{
                ...styles.link,
                color: hoveredLink === "home" ? "#FFD400" : "#fff",
                transform:
                  hoveredLink === "home" ? "translateX(10px)" : "translateX(0)",
              }}
              onMouseEnter={() => setHoveredLink("home")}
              onMouseLeave={() => setHoveredLink("")}
            >
              Home
            </Link>
            <Link
              to="/about"
              style={{
                ...styles.link,
                color: hoveredLink === "About Us" ? "#FFD400" : "#fff",
                transform:
                  hoveredLink === "About Us"
                    ? "translateX(10px)"
                    : "translateX(0)",
              }}
              onMouseEnter={() => setHoveredLink("About Us")}
              onMouseLeave={() => setHoveredLink("")}
            >
              About Us
            </Link>
            <Link
              to="/Scrapservices1"
              style={{
                ...styles.link,
                color: hoveredLink === "Solutions" ? "#FFD400" : "#fff",
                transform:
                  hoveredLink === "Solutions"
                    ? "translateX(10px)"
                    : "translateX(0)",
              }}
              onMouseEnter={() => setHoveredLink("Solutions")}
              onMouseLeave={() => setHoveredLink("")}
            >
              Solutions
            </Link>
            <Link
              to="/resources"
              style={{
                ...styles.link,
                color: hoveredLink === "Resources" ? "#FFD400" : "#fff",
                transform:
                  hoveredLink === "Resources"
                    ? "translateX(10px)"
                    : "translateX(0)",
              }}
              onMouseEnter={() => setHoveredLink("Resources")}
              onMouseLeave={() => setHoveredLink("")}
            >
              Resources
            </Link>
            <Link
              to="/contact"
              style={{
                ...styles.link,
                color: hoveredLink === "Contact Us" ? "#FFD400" : "#fff",
                transform:
                  hoveredLink === "Contact Us"
                    ? "translateX(10px)"
                    : "translateX(0)",
              }}
              onMouseEnter={() => setHoveredLink("Contact Us")}
              onMouseLeave={() => setHoveredLink("")}
            >
              Contact Us
            </Link>
          </ul>
        </div>

        {/* Services */}
        <div>
          <h3 style={styles.heading}>Our Services</h3>

          <ul style={styles.list}>
            <li style={styles.link}>Industrial Products</li>
            <li style={styles.link}>Engineering Solutions</li>
            <li style={styles.link}>Supply Chain Support</li>
            <li style={styles.link}>Consulting</li>
            <li style={styles.link}>Maintenance Services</li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 style={styles.heading}>Contact Info</h3>

          <div style={styles.contactItem}>
            <MapPin color="#FFD400" size={18} />
            <span>Mayur Vihar Phase 1, Delhi</span>
          </div>

          <div style={styles.contactItem}>
            <Phone color="#FFD400" size={18} />
            <span>+91 9876543210</span>
          </div>

          <div style={styles.contactItem}>
            <Mail color="#FFD400" size={18} />
            <span>info@jainaenterprises.com</span>
          </div>
        </div>
      </div>

      <div style={styles.bottom}>
        © {new Date().getFullYear()} Jaina Enterprises. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
